import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Represents the FilterFranchisesView class, extending JetView.
 */
export default class FilterFranchisesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Id',
                            type: 'number',
                            label: "<span class='icon-id'></span>" + _('Franquicia Id'), // Label for franchise ID
                            labelPosition: 'top',
                            placeholder: _('Franquicia Id'), // Placeholder for input
                            invalidMessage: _('Franchise Id is required'), // Validation message
                        },
                        {
                            view: 'text',
                            name: 'Name',
                            label: "<span class='icon-user'></span>" + _('Nombre'), // Label for name
                            labelPosition: 'top',
                            placeholder: _('Nombre'), // Placeholder for input
                            invalidMessage: _('Nombre is required'), // Validation message
                        },
                        {
                            view: 'text',
                            name: 'abreviado',
                            label: "<span class='icon-user'></span>" + _('Abreviado'), // Label for name
                            labelPosition: 'top',
                            placeholder: _('Abreviado'), // Placeholder for input
                            invalidMessage: _('Abreviado is required'), // Validation message
                        },
                        {
                            view: 'richselect',
                            name: 'IsActivate',
                            label: "<span class='icon-state'></span>" + _('Estado'), // Label for activation state
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [
                                { id: 'null', value: _('Todos') }, // Option for all
                                { id: 'A', value: _('Activado') }, // Option for activated
                                { id: 'I', value: _('Inactivado') }, // Option for deactivated
                            ],
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 250 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing input fields
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Añadir Franquicia'), // Button label for adding franchise
                            hidden: !devConfig.getPermAction('FranchisesAdd', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-ProvidersAdd',
                            type: 'form',
                            width: screen == 'small' ? 0 : 150, // Conditional width based on screen size
                            click: () => {
                                this.app.callEvent('addFranchises:button', [[]]); // Event call for adding franchise
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Limpiar'), // Button label for clearing inputs
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            click: () => {
                                this.getRoot().clear(); // Clear form inputs
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Consultar'), // Button label for consulting
                            type: 'form',
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('franchises:filter', [filterdata]); // Event call for filtering franchises
                                $$('b1').collapse(); // Collapse the accordion section
                                $$('a5').scrollTo(100, 0); // Scroll to a specific position
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true, // Initial state of the accordion
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion section
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Contains upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section1], // Main layout of the form
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object passed during initialization.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide elements based on screen width
                $$('grav2').hide();
                $$('grav3').hide();
            }
        });
    }
}

// FILE DOCUMENTED
